import { Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'app-sidebar-button[icon][text]',
    template: `
    <button type="button" class="btn text-muted text-hover-primary btn-focus-no-shadow" [disabled]="isDisabled">
      <span class="d-flex w-100 flex-column align-items-center">
        <span class="position-relative">
          <span class="material-icons md-24 icon-img" [title]="text">{{icon}}</span>
          <span *ngIf="badge !== 0"
            class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">{{badge}}</span>
        </span>
        <span class="d-none icon-text">{{text}}</span>
      </span>
    </button>
  `,
    styles: [`
    @use 'variables' as *;
    @media (min-height: $screen-height-desktop) {
      .icon-img {
        pointer-events: none;
      }

      .icon-text {
        display: block !important;
      }
    }
    .badge {
      min-width: 18px;
      min-height: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `],
    standalone: false
})
export class SidebarButtonComponent {
  @Input() icon!: string;
  @Input() text!: string;
  @Input() badge: number | string = 0;
  @Input() set disabled(isDisabled: boolean) {
    this.pointerEvents = isDisabled ? 'none' : 'auto';
    this.isDisabled = isDisabled;
  }

  @HostBinding('style.pointer-events') pointerEvents = 'auto';

  isDisabled = false;
}
